import { BookitoBookingFormValues } from './types';

export function sanitizeInitialBookingData(
  initialEditData?: BookitoBookingFormValues
): BookitoBookingFormValues | undefined {
  if (!initialEditData) {
    return undefined;
  }

  return {
    ...initialEditData,
    comment: initialEditData.comment ?? '',
  };
}

export function mapTimeFrameToTimeSlots(
  timeframes: { startTime: string; endTime: string; isAllDayEvent: boolean }[],
  timeslots: { startDateTime: string; numOfConfirmedParticipants?: number | undefined }[]
) {
  return timeframes.map(({ startTime, endTime, isAllDayEvent }) => {
    if (isAllDayEvent) {
      return {
        startTime,
        endTime,
        timeslots,
      };
    }

    const [startTimeHours, startTimeMins] = startTime.split(':');
    const mappedStartTime = new Date();
    mappedStartTime.setHours(parseInt(startTimeHours), parseInt(startTimeMins));

    const [endTimeHours, endTimeMins] = endTime.split(':');
    const mappedEndTime = new Date();
    mappedEndTime.setHours(parseInt(endTimeHours), parseInt(endTimeMins));

    const filteredSlots = timeslots.filter(({ startDateTime }) => {
      const timeslotDate = new Date(startDateTime);
      const [slotHours, slotMins] = timeslotDate.toLocaleTimeString().split(':');

      const mappedTimeSlot = new Date();
      mappedTimeSlot.setHours(parseInt(slotHours), parseInt(slotMins));

      return (
        mappedStartTime.getTime() <= mappedTimeSlot.getTime() &&
        mappedTimeSlot.getTime() <= mappedEndTime.getTime()
      );
    });

    return { startTime, endTime, timeslots: filteredSlots };
  });
}
